// extracted by mini-css-extract-plugin
export default {"root":"IconShortList_root__0BYHY"};